
import React from 'react';
import { Button } from "@/components/ui/button";
import { PhoneCall, BarChart2, Zap, ChevronRight } from 'lucide-react';
import { Link } from 'react-router-dom';

const HowItWorks: React.FC = () => {
  const steps = [
    {
      icon: <PhoneCall className="h-10 w-10 text-white" />,
      title: "Discovery Call",
      description: "We identify where AI can deliver the biggest impact for your business.",
      color: "from-primary to-primary/80"
    },
    {
      icon: <BarChart2 className="h-10 w-10 text-white" />,
      title: "Custom AI Strategy",
      description: "We develop and deploy AI solutions tailored to your specific needs.",
      color: "from-heading-secondary to-heading-secondary/80"
    },
    {
      icon: <Zap className="h-10 w-10 text-white" />,
      title: "Implementation & Growth",
      description: "AI starts working for you, with ongoing optimization for maximum results.",
      color: "from-heading-accent to-heading-accent/80"
    }
  ];

  return (
    <section id="how-it-works" className="py-20 px-6 md:px-10 bg-gray-900 text-white">
      <div className="container mx-auto">
        <div className="text-center mb-16">
          <div className="inline-flex items-center px-3 py-1 rounded-full bg-heading-accent/20 text-heading-accent mb-4 animate-fade-in">
            <span className="text-sm font-medium">The Process</span>
          </div>
          <h2 className="text-3xl md:text-4xl font-bold mb-4 animate-fade-in">Your AI Journey, Simplified</h2>
          <p className="text-lg text-white/80 max-w-2xl mx-auto animate-fade-in delay-200">
            We've streamlined the AI implementation process to make it straightforward and effective.
          </p>
        </div>
        
        <div className="relative">
          {/* Removed the vertical connect line */}
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-8 relative">
            {steps.map((step, index) => (
              <div 
                key={index} 
                className="flex flex-col items-center text-center animate-fade-in-up"
                style={{ animationDelay: `${index * 200}ms` }}
              >
                <div className={`w-20 h-20 rounded-full flex items-center justify-center bg-gradient-to-br ${step.color} shadow-lg mb-6 relative z-10`}>
                  {step.icon}
                </div>
                <h3 className="text-xl font-bold mb-3 text-white">{step.title}</h3>
                <p className="text-white/80">{step.description}</p>
              </div>
            ))}
          </div>
          
          <div className="mt-12 text-center w-full">
            <Button asChild className="btn-hover-effect px-6 py-5 text-lg font-medium animate-fade-in-up delay-800 bg-heading-accent hover:bg-heading-accent/90 text-white flex items-center gap-2 mx-auto w-auto max-w-xs">
              <Link to="/ai-consulting">
                Let's Build Your AI Strategy
                <ChevronRight className="h-4 w-4" />
              </Link>
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
